import { useTranslation } from 'react-i18next';

import { MainSegment } from 'api/responses/models/Unit/UnitStructure/MainSegment';
import { UnitIdentification } from 'api/responses/models/Unit/UnitStructure/UnitIdentification';
import { InlineDisplayValue } from 'library/components/controls/display/InlineDisplayValue';
import { TextDisplay } from 'library/components/controls/display/TextDisplay';
import { EmptyTextData } from 'library/types';
import { isUnitIndustrial } from 'modules/Shared/State/unit';

export const UnitIdentificationDisplay = ({
	mainSegment,
	unitIdentification,
	inline = false,
}: {
	mainSegment: MainSegment | null | undefined;
	unitIdentification: UnitIdentification | null | undefined;
	inline?: boolean;
}): React.JSX.Element => {
	const { t } = useTranslation('commonUnit');

	const renderDisplay = (label: string, value: EmptyTextData) => {
		return inline ? (
			<InlineDisplayValue label={label} value={value} />
		) : (
			<TextDisplay label={label} value={value} />
		);
	};

	return isUnitIndustrial(mainSegment) ? (
		<>{renderDisplay(t('machine-id'), unitIdentification?.hullMachineId)}</>
	) : (
		<>
			{renderDisplay(t('hull-id'), unitIdentification?.hullId)}
			{renderDisplay(t('imo-number'), unitIdentification?.imoNumber)}
			{renderDisplay(t('mmsi-number'), unitIdentification?.mmsiNumber)}
			{renderDisplay(t('call-sign'), unitIdentification?.callSign)}
		</>
	);
};
